import React from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import { moneyFormater, numberFormat } from 'utils/common';
import { Heading, Text, Hint } from '../../Elements/Elements';

import classes from './Forecast.module.scss';

const Forecast = ({ data }) => {
  const content = ({ amount, type = '$' }) => {
    switch (type) {
      case '$': {
        return amount || amount === 0
          ? `${amount >= 0 ? '' : '-'} ${moneyFormater(amount)}`
          : '-';
      }
      case '%': {
        return (amount && amount !== '-') || amount === 0 ? `${amount}%` : '-';
      }
      case 'days': {
        return (amount && amount !== '-') || amount === 0
          ? `${amount} days`
          : '-';
      }
      case 'digit': {
        return (amount && amount !== '-') || amount === 0
          ? numberFormat(amount)
          : '-';
      }
      default:
        return amount;
    }
  };

  return (
    <section className={classes.widget_wrap}>
      {data.map(widget => {
        return (
          <div className={classes.widget} key={widget.header}>
            <div className={classes.heading_box}>
              <Heading className={classes.heading} weight="r">
                {widget.header}
              </Heading>
              {widget.tooltip && (
                <Hint
                  className={classes.hint}
                  text={widget.tooltip}
                  position="top"
                />
              )}
            </div>
            <Text
              weight="m"
              className={cn(classes.text, widget.amount < 0 && classes.red)}
            >
              {content(widget)}
            </Text>
          </div>
        );
      })}
    </section>
  );
};

Forecast.propTypes = {
  data: PropTypes.arrayOf(object)
};

export default Forecast;
